import useGetSimulationCustomerGranteesQuery from './hooks/useGetSimulationCustomerGranteesQuery.js';
import { compose, pathOr } from 'ramda';
import { Loading } from '@fasstech/middle-design-system';
import SimulationCustomerGranteesForm from './SimulationCustomerGranteesForm.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';

const SimulationCustomerGrantees = ({
  middleFeatures,
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  regimeObligatoire,
  professionalSituations,
  phoneIndicatives,
  socioProfessionalCategories,
  activities
}) => {
  const { getSimulationCustomerGrantees, loading: isFetchingGetContract } =
    useGetSimulationCustomerGranteesQuery();

  if (isFetchingGetContract) return <Loading />;

  return (
    <SimulationCustomerGranteesForm
      getContract={getSimulationCustomerGrantees}
      middleFeatures={middleFeatures}
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      getMiddleNumber={getMiddleNumber}
      jobs={pathOr([], ['jobs'], getSimulationCustomerGrantees)}
      regimeObligatoire={regimeObligatoire}
      professionalSituations={professionalSituations}
      socioProfessionalCategories={socioProfessionalCategories}
      activities={activities}
      phoneIndicatives={phoneIndicatives}
    />
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SimulationCustomerGrantees);
